import {
  AppLanguageCountryCode,
  AppLanguageLocales,
  UserCountryCode,
  UserCountryCodes,
} from '@shared/types/countryCodes.ts';

interface DocumentHeadLanguageAttributes {
  htmlLang: string;
  ogLocale: string;
  titleSuffix: string;
  descriptionTemplate: string;
}

interface DocumentHeadCountryAttributes {
  brandName: string;
  ogUrl: string;
  jsonLdUrl: string;
  faviconHref: string;
}

export type DocumentHeadLanguage = (typeof AppLanguageLocales)[AppLanguageCountryCode];

export const documentHeadByCountry = {
  [UserCountryCodes.IT]: {
    brandName: 'Mediaset AdManager',
    ogUrl: 'https://admanager.mediaset.it/',
    jsonLdUrl: 'https://admanager.mediaset.it/it/',
    faviconHref: './favicon_default.png',
  },
  [UserCountryCodes.ES]: {
    brandName: 'Mediaset España AdManager',
    ogUrl: 'https://admanager.mediaset.es/',
    jsonLdUrl: 'https://admanager.mediaset.es/es/',
    faviconHref: './favicon_default.png',
  },
  [UserCountryCodes.DE]: {
    brandName: 'ProSiebenSat.1 AdManager',
    ogUrl: 'https://admanager.prosiebensat1.com/',
    jsonLdUrl: 'https://admanager.prosiebensat1.com/de/',
    faviconHref: './favicon_de.ico',
  },
} as const satisfies Record<UserCountryCode, DocumentHeadCountryAttributes>;

export const documentHeadByLanguage = {
  [AppLanguageLocales.IT]: {
    htmlLang: 'it',
    ogLocale: 'it_IT',
    titleSuffix: 'Gestisci le tue Campagne',
    descriptionTemplate: 'Benvenuto in {brandName}. Gestisci in autonomia le tue campagne Addressable TV.',
  },
  [AppLanguageLocales.EN]: {
    htmlLang: 'en',
    ogLocale: 'en_GB',
    titleSuffix: 'Manage your Campaigns',
    descriptionTemplate: 'Welcome to {brandName}. Independently manage your Addressable TV campaigns.',
  },
  [AppLanguageLocales.ES]: {
    htmlLang: 'es',
    ogLocale: 'es_ES',
    titleSuffix: 'Gestiona tus Campañas',
    descriptionTemplate: 'Bienvenido a {brandName}. Gestiona de forma autónoma tus campañas Addressable TV.',
  },
  [AppLanguageLocales.DE]: {
    htmlLang: 'de',
    ogLocale: 'de_DE',
    titleSuffix: 'Verwalte deine Kampagnen',
    descriptionTemplate: 'Willkommen bei {brandName}. Verwalte deine Addressable-TV-Kampagnen eigenständig.',
  },
} as const satisfies Record<DocumentHeadLanguage, DocumentHeadLanguageAttributes>;
